module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"desc":"This project is sponsored and technically supported by <b>Strategic Explorations</b>."},"zh":{"desc":"本项目由 <b>Strategic Explorations</b> 提供技术支持"}}')
  delete Component.options._Ctor
}
